import(/* webpackChunkName:"preLoadImport" */ "./preLoadImport.js");
const loadScript = (url = "", id) => {
  if (url) {
    const script = document.createElement("script");
    if (id) {
      script.id = id;
    }
    script.type = "text/javascript";
    script.src = url;
    window.document.head.appendChild(script);
  }
};
loadScript("/iuap-data-analytic/ucf-wh/sdk/common/sdk_common.js");
